import showMailLogs from './showMailLog';
import mailLogList from './mailLogList';

export default {
  list: mailLogList,
  show: showMailLogs,
};
